import { useContext } from 'react';
import { MemberContext, MemberContextData } from './context';

export function useMember(): MemberContextData {
    const data = useContext<MemberContextData | undefined>(MemberContext);

    if (!data) {
        throw new Error(
            "MemberContext unavailable. Are you sure you're using this in a nested component of an MemberContextProvider?"
        );
    }

    return {
        companyUser: data.companyUser
    };
}
